import React from 'react';

export const hasAnyPermission = (permissions: string[], hasAnyPermissions: string[]) => {
  if (permissions && permissions.length !== 0) {
    return (hasAnyPermissions.length === 0) || hasAnyPermissions.some(auth => permissions.includes(auth));
  }
  return false;
};
